import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, User, FileText, ClipboardCheck, ShieldCheck,
  Menu, X, Info, Users, BookOpen, HelpCircle, LogOut, ChevronLeft,
} from "lucide-react";

const Sidebar = ({ isCollapsed, setIsCollapsed, isMobileOpen, setIsMobileOpen }) => {
  const { pathname } = useLocation();
  const navigate     = useNavigate();

  const isActive = (path, exact = false) =>
    exact ? pathname === path : pathname.startsWith(path);

  const studentLinks = [
    { name: "Dashboard",  icon: <LayoutDashboard size={18} />, path: "/student-dashboard", exact: true },
    { name: "Profile",    icon: <User size={18} />,            path: "/student-dashboard/profile" },
    { name: "Apply",      icon: <FileText size={18} />,        path: "/student-dashboard/application" },
    { name: "Status",     icon: <ClipboardCheck size={18} />,  path: "/student-dashboard/status" },
    { name: "Eligibility",icon: <ShieldCheck size={18} />,     path: "/eligibility" },
  ];

  const infoLinks = [
    { name: "Stories",    icon: <BookOpen size={18} />,   path: "/stories" },
    { name: "About Us",   icon: <Info size={18} />,       path: "/about" },
    { name: "Leadership", icon: <Users size={18} />,      path: "/leadership" },
    { name: "Support",    icon: <HelpCircle size={18} />, path: "/support" },
  ];

  return (
    <aside className={`
      fixed md:static top-16 left-0 z-40
      h-[calc(100vh-4rem)]
      bg-white border-r border-gray-200 shadow-sm
      transition-all duration-300 ease-in-out
      ${isCollapsed ? "w-16" : "w-64"}
      ${isMobileOpen ? "block" : "hidden md:block"}
      flex flex-col
    `}>

      <div className={`flex items-center p-4 border-b border-gray-100 ${isCollapsed ? "justify-center" : "justify-between"}`}>
        {!isCollapsed && <span className="font-semibold text-primary text-sm truncate">Student Portal</span>}
        <button
          onClick={() => window.innerWidth < 768 ? setIsMobileOpen(false) : setIsCollapsed(!isCollapsed)}
          className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-700 transition-colors flex-shrink-0"
          aria-label="Toggle sidebar"
        >
          {window.innerWidth < 768 ? <X size={17} /> : isCollapsed ? <Menu size={17} /> : <ChevronLeft size={17} />}
        </button>
      </div>

      <nav className="p-3 space-y-1 flex-shrink-0">
        {studentLinks.map((link) => (
          <Link
            key={link.name}
            to={link.path}
            onClick={() => setIsMobileOpen(false)}
            title={isCollapsed ? link.name : undefined}
            className={`flex items-center gap-3 px-3 py-2 rounded-xl text-sm font-medium transition-colors duration-150 ${
              isActive(link.path, link.exact)
                ? "bg-primary text-white shadow-sm"
                : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
            }`}
          >
            <span className="flex-shrink-0">{link.icon}</span>
            {!isCollapsed && <span className="truncate">{link.name}</span>}
          </Link>
        ))}
      </nav>

      {!isCollapsed && <div className="mx-3 border-t border-gray-100" />}

      <div className="px-3 mt-3 flex-shrink-0">
        {!isCollapsed && (
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-2 px-3">Information</p>
        )}
        <div className="space-y-1">
          {infoLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              onClick={() => setIsMobileOpen(false)}
              title={isCollapsed ? link.name : undefined}
              className={`flex items-center gap-3 px-3 py-2 rounded-xl text-sm transition-colors duration-150 ${
                isActive(link.path)
                  ? "bg-gray-200 text-gray-900 font-medium"
                  : "text-gray-500 hover:bg-gray-100 hover:text-gray-700"
              }`}
            >
              <span className="flex-shrink-0">{link.icon}</span>
              {!isCollapsed && <span className="truncate">{link.name}</span>}
            </Link>
          ))}
        </div>
      </div>

      <button
        onClick={() => { localStorage.removeItem("user"); navigate("/login"); setIsMobileOpen(false); }}
        title={isCollapsed ? "Logout" : undefined}
        className="mt-auto mx-3 mb-4 flex items-center gap-3 px-3 py-2.5 rounded-xl bg-red-600 text-white hover:bg-red-700 active:scale-95 transition-all duration-150 text-sm font-medium"
      >
        <LogOut size={17} className="flex-shrink-0" />
        {!isCollapsed && "Logout"}
      </button>
    </aside>
  );
};

export default Sidebar;